const InfoSVG = ({ size = 48, color = "currentColor", className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer Circle */}
      <circle cx="12" cy="12" r="10" />

      {/* Dot */}
      <circle cx="12" cy="8" r="1" fill={color} stroke="none" />

      {/* Vertical Line */}
      <line x1="12" y1="11" x2="12" y2="16" />
    </svg>
  );
};

export default InfoSVG;
